import { TagAppearance } from '@zg-rentals/ts-your-rental-api-client';

export const TAG_APPEARANCE_MAP = {
  [TagAppearance.INFO]: 'gray',
  [TagAppearance.SUCCESS]: 'green',
  [TagAppearance.WARNING]: 'yellow',
  [TagAppearance.CRITICAL]: 'red',
} as const;
